// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar[data-v-1d04572e] {\n  height: 12px;\n  overflow: hidden;\n  position: relative;\n  background: #fff;\n  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);\n          box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
